import { Flex, Skeleton } from 'antd';
import { ErrorListDisplay } from 'components/ErrorDisplay';
import { BaseHeader } from 'components/header';
import { PrintableRootPage } from 'components/page/page-2';
import { ConcussionRXLogo } from 'features/sign-in/v2/concussionRx-logo';
import useSearchParams from 'lib/hooks/use-searchParams';
import { useErrorList } from 'lib/utils/useErrorList';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useClaimOnboardingTokenMutation } from '../_hooks/useClaimOnboardingTokenMutation';

export default function AuthenticatedRegistrationFlow() {
  const history = useHistory();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const errorList = useErrorList();
  const claimTokenMutation = useClaimOnboardingTokenMutation();

  useEffect(() => {
    if (token) {
      claimTokenMutation.mutate(token, {
        onSuccess: (res: any) => {
          const clinicId = res.data?.clinicId;
          history.push(`/onboarding/setup/${clinicId}`);
        },
        onError: (err: any) => {
          errorList.addError(err);
        }
      });
    } else {
      errorList.addError(new Error('No onboarding token found in URL.'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (claimTokenMutation.isPending) {
    return (
      <PrintableRootPage>
        <BaseHeader headerStyle={{ background: 'none' }} />
        <Flex vertical align="center" justify="center" gap={16} style={{ height: '60vh' }}>
          <ConcussionRXLogo style={{ width: 'revert', height: '50px', marginBottom: '20px' }} />
          <Skeleton active />
          <div>Claiming onboarding token...</div>
        </Flex>
      </PrintableRootPage>
    );
  }

  if (errorList.hasErrors) {
    return (
      <PrintableRootPage>
        <BaseHeader headerStyle={{ background: 'none' }} />
        <Flex vertical align="center" justify="center" gap={16} style={{ padding: '40px' }}>
          <ConcussionRXLogo style={{ width: 'revert', height: '50px', marginBottom: '20px' }} />
          <ErrorListDisplay errorList={errorList} />
        </Flex>
      </PrintableRootPage>
    );
  }

  return (
    <PrintableRootPage>
      <BaseHeader headerStyle={{ background: 'none' }} />
      <Flex vertical align="center" justify="center" gap={16} style={{ height: '60vh' }}>
        <ConcussionRXLogo style={{ width: 'revert', height: '50px', marginBottom: '20px' }} />
        <Skeleton active />
      </Flex>
    </PrintableRootPage>
  );
}
